/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Open_AdmissionInputs */

const en_verify_open_admission = /** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Admission`)
};

const es_verify_open_admission = /** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admisión Abierta`)
};

const fr_verify_open_admission = /** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admission libre`)
};

const de_verify_open_admission = /** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offener Einlass`)
};

const id_verify_open_admission = /** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiket Terbuka`)
};

/** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */
const ja_verify_open_admission = en_verify_open_admission;

/** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */
const zh_verify_open_admission = en_verify_open_admission;

/** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */
const ar_verify_open_admission = en_verify_open_admission;

/** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */
const it_verify_open_admission = en_verify_open_admission;

/** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */
const ru_verify_open_admission = en_verify_open_admission;

/** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */
const pt_verify_open_admission = en_verify_open_admission;

/** @type {(inputs: Verify_Open_AdmissionInputs) => LocalizedString} */
const ko_verify_open_admission = en_verify_open_admission;

/**
* | output |
* | --- |
* | "Open Admission" |
*
* @param {Verify_Open_AdmissionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_open_admission = /** @type {((inputs?: Verify_Open_AdmissionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Open_AdmissionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_open_admission(inputs)
	if (locale === "es") return es_verify_open_admission(inputs)
	if (locale === "fr") return fr_verify_open_admission(inputs)
	if (locale === "de") return de_verify_open_admission(inputs)
	if (locale === "ja") return ja_verify_open_admission(inputs)
	if (locale === "zh") return zh_verify_open_admission(inputs)
	if (locale === "ar") return ar_verify_open_admission(inputs)
	if (locale === "id") return id_verify_open_admission(inputs)
	if (locale === "it") return it_verify_open_admission(inputs)
	if (locale === "ru") return ru_verify_open_admission(inputs)
	if (locale === "pt") return pt_verify_open_admission(inputs)
	return ko_verify_open_admission(inputs)
});